import type { BrandConfig } from '../types';

export const d247: BrandConfig = {
  id: 'd247',
  name: 'D247 Admin',
  title: 'D247 Admin',
  colors: {
    // #0088cc  ->  hsl(201 100% 40%)
    primaryHsl: '201 100% 40%',
    primary: '#0088cc',
  },
  assets: {
    logo: '/brands/d247/logo.png',
    favicon: '/brands/d247/favicon.ico',
    favicon32: '/brands/d247/favicon-32x32.png',
    appleTouchIcon: '/brands/d247/apple-touch-icon.png',
  },
};
